import { API } from "aws-amplify";
import axios from 'axios';
import "containers/common/List.css";
import React, { Component } from "react";
import { Alert, Button, Col, Form, Modal, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactTable from "react-table";
import 'react-table/react-table.css';




const CancelToken = axios.CancelToken;
const source = CancelToken.source();

export default class NzSuburbList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            nzsuburbs: [],
            filter: {},
            showAlert: false,
            showWarning: false,
            errorMessage: "",
            savingNewRecord: false,
            suburb: null,
            scope: null,
            dataSetPrimaryKey: "nz_postcode_id"
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    

    async componentDidMount() {
        console.log("In NZSuburbList componentDidMount");
        this.setState({ isLoading: true });      
        if (!this.props.isAuthenticated) { // if false
            return;
        }

        
        try {
            const nzsuburbs = await this.getSuburbs({
                                                        suburb: null,
                                                        scope: null
                                                    });
            this.setState({ nzsuburbs });
        } catch (e) {
            alert(e);
        }

        this.setState({ isLoading: false });      
    }

    
    componentWillUnmount() {
        source.cancel();
        
        
        this.setState({ nzsuburbs: [] });        
    }


    
    async getSuburbs(filter) {
        console.log("Inside getSuburbs() ");
        
        return API.get("colin", "/nzsuburbs", {'queryStringParameters': filter});
      
    }

    

    addRecord = async event => {
        let nzsuburbs = [...this.state.nzsuburbs];

        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        nzsuburbs.unshift({
            cityscope: "",
            place: "",
            district: "",
            postcode: "",
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true

        });
        this.setState({nzsuburbs});
    }

    

    async saveRecord(record) {
        
        record.last_edited_by= this.props.user;
        //If the record is a new record perform a post
        if (record.hasOwnProperty("new_record")) {
            if (record.new_record === true) {
                record.last_edited_by = this.props.user;
                
                return API.post("colin", `/nzsuburbs/new`, {
                    body: record
                });
                
                
            }
        }
    
        return API.put("colin", `/nzsuburbs/${record["nz_postcode_id"]}`, {
            body: record
        });
        
        

       
    }

    

    handleChange = event => {
        console.log("Inside handleChange");
        this.setState({
            [event.target.id]: event.target.value
        });
        
    }

   

    async handleSubmit(event) {
        
        event.preventDefault();
        this.setState({ isLoading: true });
        
        const nzsuburbs = await this.getSuburbs( {
                            suburb: this.state.suburb,
                            scope: this.state.scope
                        });

        this.setState({ nzsuburbs });

        this.setState({ isLoading: false });
                
     }




    validateRecord(record) {

       
        //Check street name not blank
        if (record.place === "") {
            return [false,"Suburb cannot be blank. The record has not been saved"];
        }
      
        if (record.postcode === "") {
            return [false,"Postcode cannot be blank. The record has not been saved"];
        }
       
        return [true,];
    }


    async handleDataSave(data) {
        try {
            return await this.saveRecord(data);


        } catch (e) {
            alert("Error saving");
        }
    }

    handleInputChange = (cellInfo, event) => {
        console.log(typeof (event.target.value));
        let nzsuburbs = [...this.state.nzsuburbs];
        nzsuburbs[cellInfo.index][cellInfo.column.id] = event.target.value;
        nzsuburbs[cellInfo.index].modified = true;
        this.setState({nzsuburbs});
    };
    handleNumberChange = (cellInfo, event) => {
        let nzsuburbs = [...this.state.nzsuburbs];
        let val = event.target.value.replace(/[^0-9.]/g, "");
        
        nzsuburbs[cellInfo.index][cellInfo.column.id] = Number(val);
        nzsuburbs[cellInfo.index].modified = true;
        this.setState({nzsuburbs});
    };
    handleCheckboxChange = (cellInfo, event) => {
        let nzsuburbs = [...this.state.nzsuburbs];
        nzsuburbs[cellInfo.index][cellInfo.column.id] = event.target.checked;
        nzsuburbs[cellInfo.index].modified = true;
        this.setState({nzsuburbs});
    };

    handleDateChange = (cellInfo, event) => {
        let nzsuburbs = [...this.state.nzsuburbs];
        nzsuburbs[cellInfo.index][cellInfo.column.id] = new Date(event);
        nzsuburbs[cellInfo.index].modified = true;
        this.setState({nzsuburbs});

    }

    handleSave = async (cellInfo, event) => {
        
        this.setState({ showAlert: false, showWarning: false });
        let nzsuburbs = [...this.state.nzsuburbs];
        for (var i=0; i<nzsuburbs.length; i++){
            const validation = this.validateRecord(nzsuburbs[i]);
            console.log(validation[0]);
            if (validation[0] === true) {
                if (nzsuburbs[i].hasOwnProperty("modified")) {
                    if (nzsuburbs[i].modified === true) {
                        console.log(i);
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (nzsuburbs[i].hasOwnProperty("new_record")) {
                                if (nzsuburbs[i].new_record === true) {
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.handleDataSave(nzsuburbs[i]);
                            if (result.result) {
                                nzsuburbs[i].modified = false;
                                if (nzsuburbs[i].hasOwnProperty("new_record")) {
                                    if (nzsuburbs[i].new_record === true) {

                                        nzsuburbs[i][this.state.dataSetPrimaryKey] = result.id;
                                        this.setState({ savingNewRecord: false });
                                    }
                                    nzsuburbs[i].new_record = false;
                                }
                                                               
                            }
                            else {
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                                this.setState({ savingNewRecord: false });
                            }
                        }
                    }

                }
            }
            else {
                this.setState({ errorMessage: validation[1] });
                if (nzsuburbs[i].new_record === true) {
                    this.setState({ showWarning: true });
                }
                else{
                    this.setState({ showAlert: true });
                }
                this.setState({ savingNewRecord: false });
                return;
            }
        }   
        if (nzsuburbs[0].hasOwnProperty("sort_order")) {
            nzsuburbs.sort(function (a, b) { return a.sort_order - b.sort_order });
        }
        
        this.setState({nzsuburbs});

    }


    renderEditable = cellInfo => {
        const cellValue = this.state.nzsuburbs[cellInfo.index][cellInfo.column.id];


        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        onBlur={this.handleSave.bind(null, cellInfo)}

                    />);

                    case "number":
                        return (
                            <input
                                onChange={this.handleNumberChange.bind(null, cellInfo)}
                                onBlur={this.handleSave.bind(null, cellInfo)}
                                type="number"
                                className="no-border form-control"
                                value={cellValue!=null? cellValue: " "}
        
                            />
                        );
        
                    default:
                        if (cellInfo.column.id.indexOf("date") >= 0) {
                            return (
                                <DatePicker
                                    selected={cellValue!=null?  new Date(cellValue):""}
                                    onChange={this.handleDateChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    
                                    dateFormat="dd/MM/yyyy"
                                    className="no-border form-control"
                                />);
                        }
                        else {
                            return (
                                <input
                                    onChange={this.handleInputChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    type="text"
                                    className="no-border form-control"
                                    value={cellValue!=null? cellValue:""}
        
                                />
                            );
                        }
        }
    }

    
    
    
    
      
    
    renderTable(data) {
        const columns = [

            {
                id: 'nz_postcode_id',
                Header: 'ID',
                maxWidth: 150,
                accessor: 'nz_postcode_id' ,
                Cell: this.renderEditable
                

        }
        , {
                id: 'cityscope',
                Header: 'Cityscope',            
                accessor: 'cityscope',
                maxWidth: 250,
                Cell: this.renderEditable
                

            }, {
                id: 'place',
                Header: 'Place',            
                accessor: 'place',
                maxWidth: 150,
                Cell: this.renderEditable

            }
            ,
            {
                id: 'district',
                Header: 'District',              
                accessor: 'district',
                maxWidth: 150,
                Cell: this.renderEditable

            },
            {
                id: 'postcode',
                Header: 'Postcode',
                maxWidth: 150,
                accessor: 'postcode',
                Cell: this.renderEditable

            },
            {
                id: 'created_by',
                Header: 'Created By',
                maxWidth: 150,
                accessor: 'created_by'
            },
            {
                id: 'last_edited_by',
                Header: 'Last Edited By',
                maxWidth: 150,
                accessor: 'last_edited_by'
            }
        ]          

        if (!data) {
            return null
        }
        else {
            
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={30}
                    sortable={true}
                />
            )
        }
    }

    
    renderComponent() {
        return (
            <div className="nzsuburbs">
                <Modal show={this.state.showAlert} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
                {this.state.showWarning &&
                                <Alert variant="danger">{this.state.errorMessage}</Alert>
                            }
                <Form onSubmit={this.handleSubmit}>
                    <Form.Row >

                        
                        <Col lg={2}>
                            <Form.Group controlId="suburb">
                                <Form.Control
                                    value={this.state.suburb}
                                    onChange={this.handleChange}
                                    componentClass="input"
                                    type="text"
                                    placeholder="Place"
                                />
                            </Form.Group>
                            </Col>
                        
                        <Col lg={2}>
                        <Form.Group controlId="scope">
                                <Form.Control
                                    type="input"
                                    value={this.state.scope}
                                    onChange={this.handleChange}
                                    placeholder="Cityscope" />
                            
                            </Form.Group>
                        </Col>                        
                        <Col lg={2}>
                        <Button type="submit" className="float-left">Search</Button>
                        </Col>
                        
                       

                    </Form.Row>
                </Form>
                        
                <Row >
                    <Col className="text-right" >                            
                            <Button variant="secondary" size="sm" onClick={this.addRecord}>Add</Button>
                            
                                
                                
                        </Col>
                    </Row>

                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                     
                        {!this.state.isLoading ? this.renderTable(this.state.nzsuburbs) : this.renderTable(this.state.nzsuburbs)  }
                        </Col>
                    </Row>
           

            </div>
        );
    }
  render() {
    return (

        <div className="SuburbList">
            {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
            
        </div>
    );
  }
}
